export function filterByClassList(nodes, list) {
  return nodes.filter(node =>
    list.some(item =>
      node.classList.contains(`pop-up--${item}`)))
}

export function filterByIdList(nodes, list) {
  return nodes.filter(node =>
    list.some(item => node.id === `pop--up--button--${item}`))
}